module.exports = __webpack_public_path__ + "static/media/strom.a9da7b90.svg";